import dayjs from 'dayjs'

import { Planning } from '@/core/models/planning.model'

export type PlanningStatus = 'active' | 'upcoming' | 'past'

export function getPlanningStatus(planning: Pick<Planning, 'startDate' | 'endDate'>, now: Date = new Date()): PlanningStatus {
  const reference = dayjs(now)

  if (dayjs(planning.startDate).isAfter(reference)) {
    return 'upcoming'
  }

  if (dayjs(planning.endDate).isBefore(reference)) {
    return 'past'
  }

  return 'active'
}

export function selectDefaultPlanning(plannings: Planning[], planningId?: string, now: Date = new Date()): Planning | undefined {
  const visiblePlannings = plannings.filter((planning) => !planning.archived)

  if (planningId) {
    const selectedPlanning = visiblePlannings.find((planning) => planning._id === planningId)
    if (selectedPlanning) return selectedPlanning
  }

  const activePlannings = visiblePlannings
    .filter((planning) => getPlanningStatus(planning, now) === 'active')
    .sort((a, b) => dayjs(a.endDate).valueOf() - dayjs(b.endDate).valueOf())

  if (activePlannings[0]) return activePlannings[0]

  const upcomingPlannings = visiblePlannings
    .filter((planning) => getPlanningStatus(planning, now) === 'upcoming')
    .sort((a, b) => dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf())

  if (upcomingPlannings[0]) return upcomingPlannings[0]

  return visiblePlannings
    .filter((planning) => getPlanningStatus(planning, now) === 'past')
    .sort((a, b) => dayjs(b.endDate).valueOf() - dayjs(a.endDate).valueOf())[0]
}
